
    require(
      "!../../node_modules/gatsby/dist/loaders/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { 
     return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./graphql-scala-3-handling-arguments.json") })
        }
      }, "path---graphql-scala-3-handling-arguments");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby/dist/loaders/gatsby-module-loader?name=path---graphql-scala-3-handling-arguments!./.cache/json/graphql-scala-3-handling-arguments.json
// module id = ./node_modules/gatsby/dist/loaders/gatsby-module-loader/index.js?name=path---graphql-scala-3-handling-arguments!./.cache/json/graphql-scala-3-handling-arguments.json
// module chunks = 154